<template>
  <div id="addContainer">
    <div class="formWarp">
      <div class="baseInfo">
        <div class="baseInfo_title">
          <div class="titleAll">
            项目信息
          </div>
          <el-form ref="formProject" :model="formProject" :rules="rules" label-width="140px" label-position="left"
            class="demo-form-inline" size="small">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="项目名称" prop="prjName">
                  <el-input v-model="formProject.prjName" :readonly="showType == 'check'" size="small" maxlength="100"
                    show-word-limit clearable class="prjNameStyle" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="false">
                <el-form-item label="项目编号" prop="prjCode">
                  <el-input v-model="formProject.prjCode" :readonly="showType == 'check'" size="small" maxlength="50"
                    show-word-limit clearable class="prjNameStyle" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <template>
                  <el-form-item label="项目总负责人" prop="prjLeaderName">
                    <el-input v-model="formProject.prjLeaderName" readonly size="small">
                      <template slot="append">
                        <el-button type="default" :disabled="showType == 'check'" size1="small" title="选择负责人"
                          @click="managerBtn()">
                          ...
                        </el-button>
                      </template>
                    </el-input>
                  </el-form-item>
                </template>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="项目类型" prop="prjCategoryId">
                  <el-select v-model="formProject.prjCategoryId" :disabled="showType == 'check'" size="small" clearable
                    style="width: 100%" filterable @change="categoryChange">
                    <el-option v-for="item in categoryDic" :key="item.id" :label="item.cnName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" v-if="false">
                <template>
                  <el-form-item label="承接部门" prop="deptName">
                    <div class="deptName">
                      <div class="departs">
                        <span v-for="dept, index in formProject.undertakeDeptList" :key="index"
                          style="margin-right: 10px;white-space1: nowrap; ">{{ dept.deptName }}</span>
                      </div>
                      <el-button slot="right" :disabled="showType == 'check'" size="small" title="选择承接部门"
                        @click="departmentBtn">
                        ...
                      </el-button>
                    </div>
                  </el-form-item>
                </template>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目等级" prop="prjLevelId">
                  <el-select v-model="formProject.prjLevelId" :disabled="showType == 'check'" size="small"
                    style="width: 100%" clearable filterable @change="levelChange">
                    <el-option v-for="item in levelDic" :key="item.id" :label="item.cnName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="16">
                <el-form-item label="项目概述">
                  <el-input v-model="formProject.prjOverview" :readonly="showType == 'check'"
                    :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" show-word-limit
                    size="small" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="项目图片">
                  <el-upload :disabled="showType == 'check'" class="avatar-uploader" :action="action"
                    :on-success="fileOnSuccess" :headers="headers" style="width: 100%" :show-file-list="false"
                    :before-upload="dataprogress1">
                    <div class="picBox" @mouseenter="mouseenter" @mouseleave="mouseleave">
                      <img v-if="imageUrl" :src="imageUrl" class="avatar">
                      <i v-if="!imageUrl" class="el-icon-plus"></i>
                      <p v-if="!imageUrl">文件只支持png格式</p>
                      <i v-if="imageUrl && showDelete && showType != 'check'" class="el-icon-delete"
                        @click.stop="fileOnRemove"></i>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">
            业主信息
          </div>
          <el-form ref="formowner" size="small" :model="formowner" label-width="140px" label-position="left" class="demo-form-inline">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="业主名称">
                  <el-input v-model="formowner.ownerName" :readonly="showType == 'check'" size="small" maxlength="100"
                    show-word-limit clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="业主联系人">
                  <el-input v-model="formowner.ownerContact" :readonly="showType == 'check'" size="small" maxlength="100"
                    show-word-limit clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="业主联系人电话" prop="ownerContactPhone">
                  <el-input v-model="formowner.ownerContactPhone" :readonly="showType == 'check'" size="small"
                    maxlength="30" show-word-limit clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">
            详细信息
          </div>
          <el-form ref="formDetail" size="small" :model="formDetail" :rules="formDetailRules" label-width="140px"
            label-position="left" class="demo-form-inline">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="设计类别" prop="designCategoryId">
                  <el-select v-model="formDetail.designCategoryId" :disabled="showType == 'check'" size="small"
                    style="width: 100%" clearable filterable @change="designChange">
                    <el-option v-for="item in designDic" :key="item.id" :label="item.cnName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所在省市">
                  <el-cascader ref="regionSelect" v-model="region" :options="regions"
                    :placeholder="regionName" :disabled="showType == 'check'" size="small" clearable style="width:100%"
                    @change="regionChange">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="容积率(%)" prop="plotRatio">
                  <el-input v-model="formDetail.plotRatio" :readonly="showType == 'check'" size="small" type="text"
                    maxlength="10" show-word-limit clearable />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="总建筑面积(㎡)" prop="grossFloorArea">
                  <el-input v-model="formDetail.grossFloorArea" :readonly="showType == 'check'" size="small" type="text"
                    maxlength="10" show-word-limit clearable />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="总用地面积(㎡)" prop="totalLandArea">
                  <el-input v-model="formDetail.totalLandArea" :readonly="showType == 'check'" size="small" type="text"
                    maxlength="10" show-word-limit clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">
            时间信息
          </div>
          <el-form ref="formTime" size="small" :model="formTime" label-width="140px" label-position="left" class="demo-form-inline">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="计划开始时间">
                  <el-date-picker v-model="formTime.plannedStartTime" :disabled="showType == 'check'" type="datetime"
                    style="width: 100%" size="small" value-format="yyyy-MM-dd HH:mm:ss" @change="startTimeChange" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计划完成时间">
                  <el-date-picker v-model="formTime.plannedCompletionTime" :disabled="showType == 'check'"
                    :picker-options="endTime" type="datetime" style="width: 100%" size="small"
                    value-format="yyyy-MM-dd HH:mm:ss" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="showType != 'add'" :gutter="24">
              <el-col :span="8">
                <el-form-item label="最后更新时间">
                  <el-input v-model="formTime.updateDate" :disabled="showType == 'check'" size="small" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最后更新者">
                  <el-input v-model="formTime.updateUserName" :disabled="showType == 'check'" size="small" readonly />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="baseInfo_title">
          <div class="titleAll">
            其他设置
          </div>
          <el-form ref="formOthers" size="small" :model="formProject" label-width="140px" label-position="left"
            class="demo-form-inline">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="使用目录模板">
                  <dict-select v-model="formProject.folderTemplateTypeId" dictCode="folderTemplateType"
                    size="small" @dictChanged="handleTemplateTypeChanged" />
                </el-form-item>
                <div>提示：如果不选，则使用默认目录模板</div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button v-if="showType != 'check'" size="small" type="primary" @click="addprojectBtn">
        提交
      </el-button>
      <el-button size="small" plain @click="projectClose">
        关闭
      </el-button>
    </div>
    <!-- 人员 -->
    <el-dialog v-dialogDrag :visible.sync="peopleVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="peopleClose" title="选择人员" width="800px">
      <el-form style="height: 40px" size="small" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="peopleselectName" placeholder="请输入姓名或手机号" style="width: 200px" size="small" clearable
            @keyup.enter.native="getPersonList(1)">
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-form-item>
      </el-form>
      <enterprisePerson :type="2" :select-person="peopleData" @peopleDetail="peopleDetail"></enterprisePerson>
      <div class="page">
        <el-pagination v-if="page1.totalCount > 0" :current-page.sync="page1.pageNo" :page-size="page1.pageSize"
          :layout="page1.pageLayout" :total="page1.totalCount" size="small" background
          @current-change="peopleselectData" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="peopleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="peopleselsetBtn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="departmentVisible" v-dialogDrag :visible.sync="departmentVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="departmentClose" title="部门" width="30%" class="people_class">
      <div class="bottom_left">
        <org-tree ref="orgTree" @orgcurrent="currentOrgChangeHandler"></org-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="departmentClose">取 消</el-button>
        <el-button size="small" type="primary" @click="departmentselsetBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import createProjectService from "@/CommonDP/service/project-service";
import dicService from "@/CommonDP/service/dic-service";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import enterprisePerson from "@/CommonDP/components/structure/enterprisePerson.vue";
import { mapState } from "vuex";
import { uploadDataUrl, getToken, viewFile } from "@/CommonDP/utils";
import regions from "@/CommonDP/commons/region";
import dictSelect from '@/CommonDP/components/dictSelect/dictSelect';
import projectHome from '@/xgzdService/projectHome-service'

const newEmptyProjectForm = () => ({
  // prjCode: "", // 项目编号
  prjCategory: "", // 项目类型
  prjCategoryId: "",
  prjName: "", // 项目名称
  prjLeaderName: "", // 项目总负责人
  prjLeaderId: "",
  deptName: "", // 主体部门
  deptIds: [],
  undertakeDeptList: [],
  prjLevel: "", // 项目等级
  prjLevelId: "",
  prjOverview: "", // 项目概述
  fileId: "", // 项目图片
  folderTemplateTypeId: "",
  folderTemplateType: ""
});
const newEmptyOwnerForm = () => ({
  ownerName: "", // 业主名称
  ownerContact: "", // 业主联系人
  ownerContactPhone: "" // 业主联系人电话
});
const newEmptyDetailForm = () => ({
  designCategory: "", // 设计类别
  designCategoryId: "",
  provinceCity: "", // 所在省市
  provinceCode: "", // 省code
  cityCode: "", // 市code
  plotRatio: "", // 容积率
  grossFloorArea: "", // 总建筑面积
  totalLandArea: "" // 总用地面积
});
const newEmptyTimeForm = () => ({
  plannedStartTime: "", // 计划开始时间
  plannedCompletionTime: "", // 计划完成时间
  updateDate: "",
  updateUserName: ""
});

export default {
  filters: {
    deptNameDown(list) {
      return list.map(({ deptName }) => deptName).join(";");
    },
    deptNameUp(list) {
      return list.map(({ fullDeptName }) => fullDeptName).join(";");
    }
  },
  components: { orgTree, enterprisePerson, dictSelect },
  data() {
    return {
      formProject: newEmptyProjectForm(),
      formowner: newEmptyOwnerForm(),
      formDetail: newEmptyDetailForm(),
      formTime: newEmptyTimeForm(),
      rules: {
        prjName: [{ required: true, message: "项目名称不能为空", trigger: "blur" }],
        // prjCode: [{ required: true, message: "项目编号不能为空", trigger: "blur" }],
        prjLeaderName: [{ required: true, message: "项目总负责人不能为空", trigger: "change" }]
      },
      formDetailRules: {
        plotRatio: [
          {
            validator: (rule, value, callback) => {
              if (value !== "") {
                if (value >= 0 === false) {
                  callback(new Error("容积率请填写大于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        grossFloorArea: [
          {
            validator: (rule, value, callback) => {
              if (value !== "") {
                if (value >= 0 === false) {
                  callback(new Error("总建筑面积请填写大于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        totalLandArea: [
          {
            validator: (rule, value, callback) => {
              if (value !== "") {
                if (value >= 0 === false) {
                  callback(new Error("总用地面积请填写大于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      endTime: {
        disabledDate: (time) => {
          if (this.formTime.plannedStartTime) {
            return new Date(this.formTime.plannedStartTime).getTime() > time.getTime();
          } else {
            return time.getTime() < Date.now();
          }
        }
      },
      categoryDic: [],
      designDic: [],
      levelDic: [],
      submitType: "",
      showType: "",
      peopleData: [],
      currentRow: {},
      page1: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageLayout: "total, prev, pager, next,jumper" // 分页组件
      },
      peopleVisible: false,
      peopleselectName: "",
      departmentVisible: false,
      currentDepartment: {},
      props: {
        label: "name",
        key: "userID"
      },
      roleList: [],
      selectList: [],
      loading: true,
      region: [], // 选择的所属城市
      regionName: "请选择",
      action: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      imageUrl: "",
      showDelete: false
    };
  },
  computed: {
    submitForm() {
      const {
        formProject: {
          prjCode, // 项目编号
          prjCategoryId,
          prjCategory,
          prjName, // 项目名称
          prjLeaderName, // 项目总负责人
          prjLeaderId,
          // deptName, // 主体部门
          deptIds,
          undertakeDeptList,
          prjLevelId,
          prjLevel,
          prjOverview, // 项目概述
          fileId,
          folderTemplateType,
          folderTemplateTypeId
        },
        formowner: {
          ownerName, // 业主名称
          ownerContact, // 业主联系人
          ownerContactPhone // 业主联系人电话
        },
        formDetail: {
          provinceCity,
          provinceCode,
          cityCode,
          designCategoryId,
          designCategory,
          plotRatio, // 容积率
          grossFloorArea, // 总建筑面积
          totalLandArea // 总用地面积
        },
        formTime: {
          plannedStartTime, // 计划开始时间
          plannedCompletionTime // 计划完成时间
        },
        enterpriseId
      } = this;
      const params = {
        prjCode, // 项目编号
        prjCategory: prjCategoryId ? prjCategory : "", // 项目类型
        prjCategoryId,
        prjName, // 项目名称
        prjLeaderName, // 项目总负责人
        prjLeaderId,
        // deptName, // 主体部门
        deptIds,
        undertakeDeptList,
        prjLevel: prjLevelId ? prjLevel : "", // 项目等级
        prjLevelId,
        ownerName, // 业主名称
        ownerContact, // 业主联系人
        ownerContactPhone, // 业主联系人电话
        designCategory: designCategoryId ? designCategory : "", // 设计类别
        designCategoryId,
        provinceCity,
        provinceCode,
        cityCode,
        plotRatio, // 容积率
        grossFloorArea, // 总建筑面积
        totalLandArea, // 总用地面积
        prjOverview, // 项目概述
        fileId, // 项目图片
        plannedStartTime, // 计划开始时间
        plannedCompletionTime, // 计划完成时间
        prjId: this.$route.query.id,
        prjStatusId: this.$route.query.prjStatusId,
        enterpriseId,
        folderTemplateType,
        folderTemplateTypeId
      };
      if (this.showType === "add") {
        delete params.prjId;
        delete params.prjStatusId;
        delete params.prjCode
      }
      return params;
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    regions() {
      return regions || [];
    }
  },
  created() {
    this.action = uploadDataUrl();
    const { showType } = this.$route.query;
    this.setRouteName(showType);
    if (showType !== "add") {
      this.loadingTxt = "数据加载中...";
      this.loading = true;
      this.queryDetail();
    }
    this.categoryDicList();
    this.levelDicList();
    this.designDicList();
  },

  methods: {
    startTimeChange() {
      this.$set(this.formTime, "plannedCompletionTime", "");
    },
    setRouteName(showType) {
      this.showType = showType;
      const routeName = showType === "add" ? "添加" : showType === "edit" ? "编辑" : "查看";
      this.$route.meta.routeName = routeName;
      this.$store.dispatch("updateNavArr");
    },
    async queryDetail() {
      const { id: prjId } = this.$route.query;
      const res = await createProjectService.viewList(prjId);
      if (res.result === "0") {
        this.formProject = res.data;
        this.imageUrl = res.data.filePath ? viewFile(res.data.filePath, getToken()) : "";
        this.formowner = res.data;
        this.formDetail = res.data;
        this.formTime = res.data;
        // 所属省市
        this.region = [this.formDetail.provinceCode, this.formDetail.cityCode];
        this.regionName = this.formDetail.provinceCity;
      }
    },
    // 项目类别
    async categoryDicList() {
      const res = await dicService.getDicList("PrjType");
      this.categoryDic = res.data || [];
    },
    // 项目等级
    async levelDicList() {
      const res = await dicService.getDicList("PrjLevel");
      this.levelDic = res.data || [];
    },
    // 设计类别
    async designDicList() {
      const res = await dicService.getDicList("DesignCategory");
      this.designDic = res.data || [];
    },
    async addprojectBtn() {
      await this.$refs.formProject.validate();
      await this.$refs.formowner.validate();
      await this.$refs.formDetail.validate();
      const { submitForm: params } = this;
      if (this.showType === "edit") {
        await projectHome.updateProject(params);
        this.$message.success("修改成功");
        this.$store.dispatch("myProjectsChange");
      } else {
        await projectHome.initiationCreatProject(params)
        this.$message.success("添加成功");
        this.$store.dispatch("myProjectsChange");
      }
      this.$router.go(-1);
    },
    projectClose() {
      this.$router.push({ name: "createProjectList" });
    },
    managerBtn(val) {
      this.peopleType = val;
      this.peopleVisible = true;
      this.getPersonList(1);
      this.page1.pageNo = 1;
    },
    peopleDetail(val) {
      this.currentRow = val;
    },
    peopleselectData(val) {
      this.getPersonList(val);
      this.currentRow = {};
    },
    // 人员
    async getPersonList(val) {
      this.loading = true;
      const {
        page1: { pageSize },
        enterpriseId,
        peopleselectName
      } = this;
      const params = {
        pageSize,
        pageNum: val,
        keyword: peopleselectName,
        isEnabled: "",
        enterpriseId
      };
      const { data, totalCount, pageIndex } = await systemPersonService.personListTable(params);
      this.page1.pageIndex = pageIndex;
      this.page1.totalCount = totalCount;
      this.peopleData = data;
      this.loading = false;
    },
    peopleselsetBtn() {
      if (this.currentRow) {
        this.formProject.prjLeaderName = this.currentRow.name;
        this.formProject.prjLeaderId = this.currentRow.userId;
        this.$refs.formProject.clearValidate("prjLeaderName");
      }
      this.peopleVisible = false;
      this.currentRow = {};
    },
    peopleClose() {
      this.peopleselectName = "";
      this.peopleVisible = false;
      this.currentRow = {};
    },
    // 选择主体部门
    departmentBtn() {
      this.departmentVisible = true;
    },
    departmentClose() {
      this.departmentVisible = false;
      this.currentDepartment = {};
    },
    currentOrgChangeHandler(val) {
      this.currentDepartment = val;
    },
    departmentselsetBtn() {
      if (this.currentDepartment) {
        this.formProject.deptName = "";
        this.formProject.deptIds = [];
        this.formProject.undertakeDeptList = [];
        this.formProject.deptName = this.currentDepartment.deptName;
        this.formProject.deptIds.push(this.currentDepartment.deptId);
        const dep = {
          deptId: this.currentDepartment.deptId,
          deptName: this.currentDepartment.deptName,
          fullDeptName: this.currentDepartment.fullDeptName
        };
        this.formProject.undertakeDeptList.push(dep);
        this.$refs.formProject.clearValidate("deptName");
      }
      this.departmentVisible = false;
      this.currentDepartment = {};
    },
    levelChange() {
      for (const item of this.levelDic) {
        if (item.dicId === this.formProject.prjLevelId) {
          this.formProject.prjLevel = item.cnName;
        }
      }
    },
    categoryChange() {
      for (const item of this.categoryDic) {
        if (item.dicId === this.formProject.prjCategoryId) {
          this.formProject.prjCategory = item.cnName;
        }
      }
    },
    designChange() {
      for (const item of this.designDic) {
        if (item.dicId === this.formDetail.designCategoryId) {
          this.formDetail.designCategory = item.cnName;
        }
      }
    },
    fileOnSuccess(response, file) {
      if (response.result === "0" && response.data) {
        response.data.name = response.data.realName;
        this.formProject.fileId = response.data.fileKey;
        this.imageUrl = viewFile(response.data.filePath, getToken());
      }
    },
    fileOnRemove() {
      this.imageUrl = "";
      this.formProject.fileId = "";
    },
    mouseenter() {
      this.showDelete = true;
    },
    mouseleave() {
      this.showDelete = false;
    },
    dataprogress1(file) {
      const fileName = file.name.split(".");
      const fileNameLength = file.name.split(".").length;
      const isPG = fileName[fileNameLength - 1] === "png";
      if (!isPG) {
        this.$message({
          showClose: true,
          message: "项目图片只能是 .png 格式!",
          type: "warning"
        });
        return false;
      }
      const newFile = this.beforeUpload(file);
      return newFile;
    },
    // 上传图片压缩
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 2) {
        this.$message.warning("上传图片大小不能超过 2MB! 将进行压缩");
        const imageConversion = require("image-conversion");
        console.log("压缩前" + file.size / 1024 + "K");
        return new Promise((resolve, reject) => {
          imageConversion.compressAccurately(file, 2048).then((res) => {
            console.log("压缩后" + res.size / 1024 + "K");
            res = new File([res], file.name, { type: res.type, lastModified: Date.now() });
            resolve(res);
          });
        });
      } else return file;
    },
    // 所在城市改变
    regionChange(value) {
      if (value) {
        const labels = this.$refs.regionSelect.getCheckedNodes()[0].pathLabels;
        const codes = value || [];
        this.formDetail.provinceCity = labels[0] + " / " + labels[1];
        this.formDetail.provinceCode = codes[0];
        this.formDetail.cityCode = codes[1];
      }
    },

    handleTemplateTypeChanged(dict) {
      this.formProject.folderTemplateType = dict.cnName || "";
    }
  }
};
</script>
<style  lang="scss">
.baseInfo_title {
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 30px;
  }

  .el-form-item {
    margin-bottom: 6px !important;
  }
}

.people_class {
  .el-dialog__body {
    height: 300px;
  }
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
#addContainer {
  width: 100%;
  height: 100%;
  background-color: #eff1f6;
  position: relative;

  .formWarp {
    min-width: 1120px;
    height: 100%;
    overflow: auto;
    padding: 0 247px;
    box-sizing: border-box;

    .baseInfo {
      width: 100%;
      margin-bottom: 70px;
      margin-top: 10px;

      .baseInfo_title {
        background-color: #fff;
        padding: 10px 0;
        margin-bottom: 10px;
      }
    }
  }

  .btns {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 70px;
    right: 0;
    padding-right: 12px;
    border-top: 1px solid #EAEAEA;
  }

  .demo-form-inline {
    padding: 20px 40px 0px 40px;

    .avatar-uploader {
      /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      /deep/ .el-upload:hover {
        border-color: var(--theme-color);
      }

      .el-icon-plus {
        font-size: 28px;
        color: #8c939d;
        width: 224px;
        height: 50%;
        line-height: 86px;
        text-align: center;
      }

      .el-icon-delete {
        font-size: 28px;
        color: #8c939d;
        width: 224px;
        height: 114px;
        line-height: 114px;
        text-align: center;
        position: absolute;
        background: #3122223b;
        color: #fff;
        top: 0px;
        left: 0px;
      }

      .picBox {
        display: flex;
        flex-direction: column;
        height: 114px;
        width: 224px;
      }
    }

    /deep/ .el-textarea__inner {
      height: 114px !important;
    }
    .prjNameStyle{
      /deep/ .el-input__inner{
        padding-right: 78px;
      }
    }
  }

  .titleAll {
    font-size: 16px;
    line-height: 48px;
    color: var(--key-color);
    padding: 0 22px;
    font-weight: bold;
    border-bottom: 1px solid rgba(208, 215, 230, 0.75);
  }

  .bottom_left {
    height: 100%;
    overflow: auto;
  }

  .deptName {
    width: 100%;
    display: flex;
    align-items: center;

    .departs {
      width: 10px;
      border: 0px solid #DCDFE6;
      border-right: 0;
      overflow-x: auto;
      flex-grow: 1;
      display: flex;
      align-items: center;
    }

    .el-button {
      background: #F5F7FA;
      color: #909399;
      border: 1px solid #DCDFE6;
    }
  }
}
</style>
